import React                                            from 'react';
import {block}                                          from '../block';
import {UiSchemaEntry, DataCellType, ColumnCellType}    from '../@types';

const DataCell:React.FC<DataCellType> = ({row, column}) =>
    <a onClick   = {(e) => e.stopPropagation()}
       href      = {row[column.name].link}
       className = {block.el('cell-data') + block.el('cell-data-link')}
       target    = {'_blank'}
       rel       = {'noreferrer'}
    >
        {row[column.name].data}
    </a>
;

const ColumnCell:React.FC<ColumnCellType> = ({column}) =>
    <span className={block.el('cell-title')}>
        {column.title || column.name}
    </span>
;

const LinkCell: UiSchemaEntry = {
    DataCell, ColumnCell
}

export {LinkCell};
